import UPG from '../shared/images/UPG.jpeg';
import O_C_Council_1 from'../shared/images/O_C_Council_1.PNG';
import O_C_Council_2 from'../shared/images/O_C_Council_2.PNG';
import NK3 from '../shared/images/NK3.jpeg';





const list_of_events = [

  {
    id: 1,
    title: 'NO KINGS 3',
    type: 'protest',
    date: 'March 28th, Noon',
    description: 'Stand up and use your voice before they take it from you.',
    location_1: '25th and Washington',
    location_2: '',
    fliers: [NK3]
  },  
  {
    id: 2,
    title: 'ICE OUT OGDEN - Pack City Council',
    type: 'protest',
    date: 'March 24th, 6:00 PM ->',
    description: 'Hold The City accountable. ICE/DHS is violating City Codes and Lease agreements, Come tell the City Council that is absolutely unacceptable',
    location_1: 'Ogden Municipal Building, 2nd Floor',
    location_2: '2541 Washington Blvd.',
    fliers: [O_C_Council_1,O_C_Council_2]
  },
  {
    id: 3,
    title: 'URGENT -- PROTECT CITIZEN INITIATIVES',
    type: 'education',
    date: 'Feb, Ongoing',
    description: 'If repealing prop 4 wasn\'t enough, there is now an attempt to remove citizens initiatives. PLEASE go to this website utahpowergrab.com to sign/voice discontent',
    location_1: (
      <a
        href="https://utahpowergrab.com"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        utahpowergrab.com
      </a>
    ),
    location_2: '',
    fliers: [UPG]
  }
  ];
  
  export default list_of_events;